module.exports = __webpack_public_path__ + "static/img/personvip_img_avatar.7b025ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personvip_img_avatar.png
// module id = FRJh
// module chunks = 0